import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { ManagePlanTrialModalComponent } from "./ManagePlanTrialModalComponent";
import { ManagePlanTrialModalUIKitComponent } from "./ManagePlanTrialModalUIKitComponent";

export const useManagePlanTrialModal = createCompassModalSwitcher(
  ManagePlanTrialModalComponent,
  ManagePlanTrialModalUIKitComponent,
);
